import Immutable from "immutable";

import { emptyStringValueToNull } from "../../helpers/commonHelper";

const LOAD = "videoPage/LOAD";
const LOAD_SUCCESS = "videoPage/LOAD_SUCCESS";
const LOAD_FAIL = "videoPage/LOAD_FAIL";


const initialState = Immutable.fromJS({
  loading: false,
  errorMessage: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state.set("loading", true);

    case LOAD_FAIL:
      return state
        .set("loading", false)
        .set("errorMessage", action.errorMessage);

    case LOAD_SUCCESS:
      return state.set("loading", false).set("errorMessage", null);

    default:
      return state;
  }
}

export const getVideoPage = (campaignId) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    const res = await api.get(`/video-pages/${campaignId}`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS });

    if(res.count > 0) {
      return res.rows[0]
    }
    return null;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const createVideoPage = (campaignId, videoPageData) => async (
  dispatch,
  getState,
  api
) => {
  dispatch({ type: LOAD });

  try {
    const data = emptyStringValueToNull(videoPageData);

    const res = await api.post(`/video-pages/${campaignId}`, { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
    }
    dispatch({ type: LOAD_SUCCESS });

    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
    return error;
  }
};

export const updateVideoPage = (campaignId, videoPageData) => async (
  dispatch,
  getState,
  api
) => {
  dispatch({ type: LOAD });

  try {
    const data = emptyStringValueToNull(videoPageData);

    const res = await api.put(`/video-pages/${campaignId}`, { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
    }
    dispatch({ type: LOAD_SUCCESS });

    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
    return error;
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/videoPage.js